import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../store';
import {conditional} from '../../util/conditional';
import {filterAndJoin} from '../../util/filterAndJoin';
import {pimText, pimTextDebug} from '../../util/values';

@customElement('shared-light-engine')
export class sharedLightEngine extends connect(store)(LitElement) {

	static styles = css`

	  .page-container {
		  display: flex;
		  margin: var(--specsheet-medium-gap) var(--specsheet-large-gap);

	  }

	  .diagrams {
		  width: 35%;
	  }

	  .description {
		  font: var(--font-specsheet-light);
		  width: 65%;
	  }

	  .downloads {
		  margin-top: 50px;
		  font: var(--font-specsheet-bold);
	  }

	  a {
		  color: #000;
	  }

	  p {
		  font: var(--font-specsheet-light);
	  }

	  p span {
		  font: var(--font-specsheet-bold);
	  }
	  .image {
		  margin-bottom: 60px;
	  }

	  .title {
		  color: var(--color-black);
		  font: var(--font-specsheet-print-light);
		  font-size: var(--font-size-sections);
		  font: var(--font-specsheet-bold);
	  }

	  .tender-text {
		margin-top: var(--specsheet-small-gap);
	  }

	  .table-title {
		font: var(--font-specsheet-bold);
	  }

	  @media print {
		  .page-container {
			  display: flex;
			  width: 100vw;
			  margin: 0;
		  }
		  .title {
			  color: var(--color-black);
			  font-size: var(--font-size-sections);
			  font: var(--font-specsheet-print-bold);
		  }

		  .diagrams {
			  width: 35%;
		  }

		  .description {
			  font: var(--font-specsheet-print-light);
			  width: 65%;
		  }

			.image {
				margin-bottom: var(--specsheet-large-gap);
			}
	  }

	`;
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
		this.decisions = this.state.decisions.data;
		this.productData = this.state.productData;

		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}
	c(id) {
		return conditional(this.decisions, this.conditionalVariantValues, id);
	}
	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.decisions, this.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.decisions, this.productData.translations, value, prefix, suffix);
	}
	render() {
		const s = this.state;
		return html`

			<div class="page-container">
				<div class="diagrams">
					<div class="image">
						<polar-diagram></polar-diagram>
					</div>
				</div>

				<div class="description">
					<div slot="content">
						<p><strong><trans-label class="title" slot="title" key="LE_LuminousFlux_OperatingTime" context="D"></trans-label></strong></p>
						<llmf-table></llmf-table>
					</div>

					<div slot="content">
						<p><strong><trans-label key="LE_LightEngineDescription" context="D"></strong></p>
						<p>
							LED ${filterAndJoin([
							this.t('LE_ColourTemperature_1', 'FV.S'),
							this.t('LE_LightDistribution_1', 'FV.S'),
							this.t('LE_CRI', 'D', null, '', ' ') + this.t(this.c('DescriptiveAttributeReference.LE_CRI'), 'DV'),
							this.t('EB_MotionSensor_1', 'FV.L'),
						], ', ')}
						</p>

						<p>
							${this.t('EB_ConstantLumenTechnology_1', 'F', null, '', ':')}
							${this.t('EB_ConstantLumenTechnology_1', 'FV.S')}
							${this.t('LU_SurgeProtection', 'D')}
							${this.t('LU_SurgeProtection.10 kV', 'DV.S', null, '', ',')}
							${this.t('LU_TechnicalRegion', 'D')}
							${this.t('LU_TechnicalRegion.220-240V 50/60 Hz', 'DV', null, '', ',')}
							${this.t('LU_AmbientTemperature', 'D')}
							${this.t('LU_AmbientTemperature.-20_+25', 'DV.S')}
							${this.t('LU_AmbientTemperatureUnit.GradCelsius', 'DV.S')}
						</p>
					</div>


				</div>
			</div>

		`;
	}
}
